import * as React from 'react';
import { useSelector } from 'react-redux';
import { Experiment } from '@cian/experiments/ab';

import { selectBrokerConsultantBannerAvailable } from '../../selectors/brokerConsultantBanner';
import { isDiscountMortgageBannerEnabled } from '../../selectors/discountMortgage';
import { getNewbuildingFlightBannerAvailable } from '../../selectors/newbuildingFlight';
import { DiscountMortgageBannerContainer } from '../DiscountMortgageBannerContainer';
import { FlightBannerContainer } from '../FlightBannerContainer';
import { BrokerConsultantBannerContainer } from '../BrokerConsultantBanner';
import { BrokerSelfRequestFormBannerContainer } from '../BrokerSelfRequestFormBannerContainer';
import { NEWBUILDING_BROKER_SELF_REQUEST_FORM } from '../../constants/experiments';

export const BannerContainer = () => {
  const isNewbuildingFlightBannerAvailable = useSelector(getNewbuildingFlightBannerAvailable);
  const isDiscountMortgageBannerAvailable = useSelector(isDiscountMortgageBannerEnabled);
  const isBrokerConsultantBannerAvailable = useSelector(selectBrokerConsultantBannerAvailable);

  if (isNewbuildingFlightBannerAvailable) {
    return <FlightBannerContainer />;
  }

  if (isDiscountMortgageBannerAvailable) {
    return <DiscountMortgageBannerContainer />;
  }

  if (isBrokerConsultantBannerAvailable) {
    // TODO: Удалить эксперимент в CD-243910.
    return (
      <>
        <Experiment name={NEWBUILDING_BROKER_SELF_REQUEST_FORM} group="A" default>
          <BrokerConsultantBannerContainer />
        </Experiment>
        <Experiment name={NEWBUILDING_BROKER_SELF_REQUEST_FORM} group="B">
          <BrokerSelfRequestFormBannerContainer />
        </Experiment>
      </>
    );
  }

  return null;
};
